import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextAligning, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxHeadline4Props extends ITextBoxProps {}

export const TextBoxHeadline4 = ({
  title,
  color = Colors.TEXT_ICON_PRIMARY,
  font = TextBoxTypes.Headline4,
  alignment = TextAligning.Left,
  ...rest
}: ITextBoxHeadline4Props): JSX.Element => {
  return (
    <TextBox
      title={title}
      color={color}
      font={font}
      alignment={alignment}
      {...rest}
    />
  )
}
